<script>
    import {
        WO_STATUS_TO_BE_ASSIGNED,
        WO_STATUS_COMPLETED,
        WorkOrderStatus,
        WO_TYPE_EQUIPMENT_MAINTENANCE
    } from '@/config/common'
    import _ from 'lodash'
    import {
        customerDetail,
        editWorkOrder,
        checkin,
        addCheckin,
        editCheckin,
        deleteCheckin,
        getSiteRecord,
        getCustomerContactDetail,
        createCustomerFeedback,
        auditingEngineer,
        auditingList,
        getAuditingLog,
        getCompanyEngineers,
        getAuditingChangeOwner,
        postAuditingAssign,
        putAuditingDetails,
        auditingAttachment,

    } from "@/service";
    import {
        getCompany,
        getEngineer,
        getDeviceInfo
    } from "@/helpers/common-service";
    import {
        addressText,
        formatDatetime
    } from "@/helpers/common";
    import ReportList from "@/views/auditing-order/components/report-list.vue";
    import DeviceInfo from "@/views/auditing-order/components/device-info.vue";
    import BusinessCard from "@/views/auditing-order/components/widgets/business-card.vue";
    import SetCompanyModal from "@/views/auditing-order/components/edit/set-company-modal.vue";
    import setEngineerModal from "@/views/auditing-order/components/edit/set-engineer-modal.vue";
    import SwiperTool from "@/components/swiperTool.vue";
    import {
        ElMessage
    } from "element-plus";
    import moment from "moment"
    import { getLanguage } from "@/i18n";
    export default {
        emits: [
            'refresh',
            'tabStatusChange',
            'pageNavTabChange', // 基本信息、服务过程、服务报告的切换，具体值看 tabOptions 
            'checkinLoaded',
        ],
        props: {
            woData: {
                type: Object,
                default () {
                    return {}
                }
            },
            auditingAssignList: {
                type: Object,
                default () {
                    return {}
                }
            },
            editType: {
                type: Boolean,
                default () {
                    return false
                }
            },
            tabStatus:{
                type: String,
                default () {
                    return '';
                }  
            }
        },
        data() {
            return {
                remark: '',
                deviceImg: null,
                checkTabVal: '1',
                tabOptions: [{
                        value: '1',
                        text: this.$t('page.basic-info')
                    },
                    {
                        value: '2',
                        text: this.$t('page.auditing.service_process'),//"服务过程"
                    },
                    {
                        value: '3',
                        text: this.$t('page.service-report.text')
                    },
                    // {
                    //   value: '4',
                    //   text: '工单日志'
                    // }
                ],
                WO_TYPE_EQUIPMENT_MAINTENANCE,
                WO_STATUS_COMPLETED,
                serviceCompanyList: [],
                engineerList: [],
                currentCustomer: {},
                currentCompanyId: null,
                currentCompany: {},
                currentMainEngineerId: null,
                currentMainEngineer: {},
                currentAssistEngineerId: null,
                currentAssistEngineer: {},
                showCompanySet: false,
                showEngineerSet: false,
                defaultSelectIdEngineerId: '', // setEngineer 弹窗中默认选择的下拉项 

                engineerType: '1',
                engineerTypeInModal: '',
                attachmentList: [],
                checkins: [],
                // 签到记录
                checkin: {},
                // 施工现场
                workSite: [],
                // 设备信息
                deviceInfo: {},
                deviceRootSn: null,
                // 联系人详情
                customerContact: {},
                // 维保项目可选项s
                maintainOptions: [],
                // currentGroupSn: null,
                feedBackForm: {
                    quality: 0,
                    attitude: 0,
                    response_speed: 0,
                    content: '',
                    work_order: null,
                },
                rateTexts: [
                    this.$t('page.rate.0'),
                    this.$t('page.rate.1'),
                    this.$t('page.rate.2'),
                    this.$t('page.rate.3'),
                    this.$t('page.rate.4'),
                    this.$t('page.rate.5'),
                ],
                showFeedbackForm: false,
                //历史
                auditingHistory: [],
                files: {
                    image: [],
                    video: [],
                    document: []
                },
                auditingLog: [],
                auditingAttachmentList: {
                    attachment: [],
                    check_in: [],
                    signature: []
                },
                // 服务进度中选择的联系人tabid
                contactTabid: '',
                tabStatus_:''
            }
        },
        computed: {
            feedbackExist() {
                return this.woData.feedback && this.woData.feedback.quality
            },
            statusArr() {
                if (this.woData.status == 4) {
                    return [this.$t('page.canceled')]
                }
                return [this.$t('page.dispatched'), this.$t('page.construction'), this.$t('page.completedWorkOrder')]
            },
            statusNow() {
                let current = _.find(WorkOrderStatus, ['value', parseInt(this.woData.status)])
                if (current) {
                    if (current['label'] == this.$t('page.completed')) {
                        return this.$t('page.completedWorkOrder')
                    }
                    return current['label'].replace(this.$t('page.processWait'), '')
                }
                return ''
            },
            canEditable() {
                // 工单状态：'1':'待施工','2':'施工中','3':'已完成','4':'已取消'
                // 只有'待施工'的可以更改
                return [1].includes(parseInt(this.woData.status))
            },
            // 其他信息是否有编辑权限
            otherInfoEditPerm() {
                return this.hasPermissionFor('order.other.patch')
            },
            permission() {
                return JSON.parse(localStorage.getItem("permission"));
            },
            // 销售服务工程师是否可以修改派工信息
            saleRoleCanEdit() {
                // 可编辑 && 是销售服务工程师
                // 工单状态：'1':'待施工','2':'施工中','3':'已完成','4':'已取消'
                return this.canEditable && this.permission.includes('auditing.role.sale')
            },
            // 是否可以更改授权服务工程师
            agentRoleEdit() {
                // 是代理商 && 可编辑 && 是代理商联系人 && 前面的代理商有值
                return this.user.user_type === 'service_company' && this.canEditable && this.hasPermissionFor(
                    'order.engineer.patch') && this.getAuditingAssignListVal('authorized.company_name')
            },
            user() {
                // this.user.user_type 类型如下: 
                // manufacturer:设备制造商，nash 
                // service_company：代理商
                // customer：终端客户
                return JSON.parse(localStorage.getItem("user"));
            },
        },
        mounted() {},
        methods: {
            moment,

            //#region 表单验证相关

            // 验证所有信息
            validate() {
                if (!this.$refs['deviceinfo'].validate()) return false // 验证不通过
                // ...

                // 验证通过
                this.clearValidate()
                return true
            },
            // 清除验证信息
            clearValidate() {
                // 清除设备信息校验
                this.$refs['deviceinfo'].clearValidate()
            },

            // #endregion 表单验证相关

            getAuditingAssignListVal(key = '') {
                if (!key) return ''
                let v = _.get(this.auditingAssignList, key, '')
                return v
            },

            putAuditingDetails() {
                let params = {
                    remark: this.remark
                }
                putAuditingDetails(this.woData.id, params).then(res => {
                    console.log(res)
                })
            },

            getCompanyEngineers() {
                let params = {
                    page_size: 0
                }
                getCompanyEngineers(params).then(res => {
                    console.log(res)
                })
            },
            // 查寻服务进度
            getAuditingLogs() {
                let params = {
                    order: this.woData.id,
                    page_size: 0,
                    detail: this.contactTabid
                }
                if (!params.order || !params.detail) return
                getAuditingLog(params).then(res => {
                    let data = _.cloneDeep(res.payload)
                    data.forEach(item=>{
                        item.tit =  this.i18LogContent(item).tit
                        item.cont =  this.i18LogContent(item).cont
                    })
                    this.auditingLog = data
                })
            },
            //i18化服务进度的数据。
            i18LogContent(item){
                let tit = ''
                let cont = ''
                //当前本地语言
                const lang = getLanguage()
                if( lang == 'ch' ){ /* 中文 */
                    tit = item.title
                    cont = item.content
                }else{ /* 英文 */
                    switch (item.title) {
                        case '待施工':
                            //  content: "您的设备巡检已被受理，销售工程师 ：xxxxx"
                            {
                                let parts = item.content.split("：")
                                tit = this.$t("page.auditing.log['待施工']")
                                cont = `${this.$t("page.auditing.log['您的设备巡检已被受理，销售工程师']")}: ${parts[1]}`
                            }
                        break;
                        case '增加协助人':
                            //content: "新增了技术服务工程师：xxx" or "新增了授权服务工程师：xxxxx"
                            {
                                let parts = item.content.split("：")
                                tit = this.$t("page.auditing.log['增加协助人']")
                                if(item.title.includes('技术')){
                                    cont = `${this.$t("page.auditing.log['新增了技术服务工程师']")}: ${parts[1]}`
                                }else{ //'授权'
                                    cont = `${this.$t("page.auditing.log['新增了授权服务工程师']")}: ${parts[1]}`
                                }
                            }
                        break;                    
                        case '更换协助人':
                            //content: "您的技术服务工程师更换：xxx" or "您的授权服务工程师更换：xxxxx"\
                            {
                                let parts = item.content.split("：")
                                tit = this.$t("page.auditing.log['更换协助人']")
                                if(item.title.includes('技术')){
                                    cont = `${this.$t("page.auditing.log['您的技术服务工程师更换']")}: ${parts[1]}`
                                }else{ //'授权'
                                    cont = `${this.$t("page.auditing.log['您的授权服务工程师更换']")}: ${parts[1]}`
                                }
                                
                            }
                        break;                    
                        case '已签到':
                            //content: ""服务人员：xxxx  服务地点：xxxx"
                            {
                                let parts = item.content.split("：")
                                let parts1 = parts[1].split(" ")
                                tit = this.$t("page.auditing.log['已签到']")
                                cont = `${this.$t("page.auditing.log['服务人员']")}: ${parts1[0]}  ${this.$t("page.auditing.log['服务地点']")}: ${parts[2]}`
                            }
                        break;                    
                        case '更换Owner':
                            //content: "您的销售服务工程师更换：xxxx"
                            {
                                let parts = item.content.split("：")
                                tit = this.$t("page.auditing.log['更换Owner']")
                                cont = `${this.$t("page.auditing.log['您的销售服务工程师更换']")}: ${parts[1]}`
                            }
                        break;
                        case '提交审核':
                            //content: "技术工程师：xxx，提交审核" or "销售工程师：xxx，提交审核"
                            {
                                let parts = item.content.split("：")[1].split("，")
                                tit = this.$t("page.auditing.log['提交审核']")
                                if(item.title.includes('技术')){
                                    cont = `${this.$t("page.auditing.log['技术工程师']")}: ${parts[0]}, ${this.$t("page.auditing.log['提交审核']").toLowerCase()}.`
                                }else{ //'销售'
                                    cont = `${this.$t("page.auditing.log['销售工程师']")}: ${parts[0]}, ${this.$t("page.auditing.log['提交审核']").toLowerCase()}.`
                                }
                                
                            }
                        break; 
                        case '审核通过':
                            //content: "销售工程师：xxx，通过审核"
                            {
                                let parts = item.content.split("：")[1].split("，")
                                tit = this.$t("page.auditing.log['审核通过']")
                                cont = `${this.$t("page.auditing.log['销售工程师']")}: ${parts[0]}, ${this.$t("page.auditing.log['审核通过']").toLowerCase()}.`

                                
                            }
                        break; 
                        case '审核不通过':
                            //content: "销售工程师：xx，审核拒绝，拒绝原因：xxx"
                            {
                                let parts = item.content.split("：")
                                let parts1 = parts[1].split("，")
                                tit = this.$t("page.auditing.log['审核不通过']")
                                cont = `${this.$t("page.auditing.log['销售工程师']")}: ${parts1[0]}, ${this.$t("page.auditing.log['审核拒绝，拒绝原因']")}: ${parts[2]}.`

                                
                            }
                        break; 
                        case '服务报告签字':
                            //content: "客户联系人：xxxx已完成服务报告签字"
                            {
                                let parts = item.content.split("：")[1].split("已完成")
                                tit = this.$t("page.auditing.log['服务报告签字']")
                                cont = `${this.$t("page.auditing.log['客户联系人']")}: ${parts[0]}, ${this.$t("page.auditing.log['已完成服务报告签字']")}`
                            }
                        break; 
                        case '已完成':
                            //content: "所有服务报告签字完成，设备巡检工单完成。"
                            {
                                tit = this.$t("page.auditing.log['已完成']")
                                cont = this.$t("page.auditing.log['所有服务报告签字完成，设备巡检工单完成']")
                            }
                        break; 
                        default:
                            break;
                    }
                }
                
                return { tit, cont };
            },
            //翻译服务进度
            logContentFormat(){
                let content = ''

                
                return content;
            },
            deviceLoaded(deviceInfo) {
                const imgs = _.get(deviceInfo, 'files.image', [])
                if (imgs.length > 0) {
                    this.deviceImg = imgs[0].url
                } else {
                    this.deviceImg = null
                }
            },
            addressText,
            formatDatetime,
            getStatusProgressClass(val) {
                let activeIndex = this.statusArr.indexOf(this.statusNow)
                let index = this.statusArr.indexOf(val)
                if (activeIndex === this.statusArr.length - 1) {
                    return 'done'
                }
                if (activeIndex == index) {
                    return 'active'
                }
                if (activeIndex > index) {
                    return 'done'
                }
                return 'waiting'
            },
            getStatusText(val) {
                if (this.getStatusProgressClass(val) == 'active' && ![this.$t('page.canceled'), this.$t(
                        'page.completedWorkOrder')].includes(val)) {
                    if (val === this.$t('page.dispatched') && !this.woData.main_engineer && !this.woData.is_confirm) {
                        return val + `(${this.$t('page.workOrderProcessing')})`
                    } else if (val === "派工" && this.woData.main_engineer && !this.woData.is_confirm) {
                        return val + `(${this.$t('page.toBeConfirmed')})`
                    } else {
                        return val + `(${this.$t('page.workOrderProcessing')})`
                    }
                }
                return val
            },
            // 添加或切换服务商
            editCompanyCommit(id) {
                const form = {
                    id: this.woData.id,
                    service_company: id,
                    status: 1
                }
                // 如果服务商变了，提交修改，清空工程师
                if (this.woData.service_company != form.service_company) {
                    form['main_engineer'] = null
                    form['assist_engineer'] = null
                    form['is_reassign'] = false
                    // this.clearCheckin()
                    this.edit(form)
                }
                this.showCompanySet = false
            },
            // 添加或切换工程师
            openEngineerSet(type) {
                this.engineerType = type
                this.showEngineerSet = true
                this.$refs.setEngineer.getEngineer(type);
                // 选择代理商的时候默认绑定之前使用的代理商 -注意：必须放getEngineer方法后面
                if (this.saleRoleCanEdit && type === '3') {
                    this.defaultSelectIdEngineerId = this.woData?.default_service_company_id || ''
                } else {
                    this.defaultSelectIdEngineerId = ''
                }
            },
            engineerChanged(value) {
                this.showEngineerSet = false
                let params
                switch (this.engineerType) {
                    case "1":
                        params = {
                            engineer_id: value
                        }
                        getAuditingChangeOwner(this.woData.id, params).then(res => {
                            console.log(res)
                            this.$emit('refresh')
                            ElMessage.success(this.$t("page.auditing['销售服务工程师修改成功']"))
                        })
                        break;
                    case "2":
                        params = {
                            company_type: 1,
                            order: this.woData.id,
                            assignee: value
                        }
                        postAuditingAssign(params).then(res => {
                            console.log(res)
                            this.$emit('refresh')
                            ElMessage.success(this.$t("page.auditing['技术服务工程师修改成功']"))

                        })
                        break;
                    case "3":
                        params = {
                            service_company: value
                        }
                        putAuditingDetails(this.woData.id, params).then(res => {
                            console.log(res)
                            this.$emit('refresh')
                            ElMessage.success(this.$t("page.auditing['代理服务修改成功']"))

                        })
                        break;
                    case "4":
                        params = {
                            company_type: 2,
                            order: this.woData.id,
                            assignee: value
                        }
                        postAuditingAssign(params).then(res => {
                            console.log(res)
                            this.$emit('refresh')
                            ElMessage.success(this.$t("page.auditing['授权服务工程师修改成功']"))

                        })
                        break;

                }
            },
            // 删除工程师
            deleteEngineer(type) {
                const form = {
                    id: this.woData.id
                }
                if (type == 'main') {
                    this.currentMainEngineerId = null
                    form['main_engineer'] = null
                    // 清空原工程师的签到记录
                    // this.clearCheckin(this.woData.main_engineer)
                }
                if (type == 'assist') {
                    this.currentAssistEngineerId = null
                    form['assist_engineer'] = null
                    // 清空原工程师的签到记录
                    // this.clearCheckin(this.woData.assist_engineer)
                }
                // 如果没有服务商或者没有工程师，变成待派工
                if (!this.currentCompanyId || (!this.currentMainEngineerId && !this.currentAssistEngineerId)) {
                    form['status'] = WO_STATUS_TO_BE_ASSIGNED
                }
                this.edit(form, false, true)
            },
            // 删除服务商
            deleteCompany() {
                this.currentCompanyId = null
                const form = {
                    id: this.woData.id,
                    service_company: null,
                    status: 1,
                    main_engineer: null,
                    assist_engineer: null,
                    is_reassign: false,
                }
                // 清空签到记录
                // this.clearCheckin()
                this.edit(form)
            },
            // 获取服务商
            getCompany() {
                getCompany().then(res => {
                    this.serviceCompanyList = res
                    if (this.currentCompanyId) {
                        this.currentCompany = _.find(res, ['id', this.currentCompanyId]) || {}
                    } else {
                        this.currentCompany = {}
                    }
                })
            },
            getEngineer(companyId) {
                getEngineer(companyId).then(res => {
                    this.engineerList = res
                    if (this.currentMainEngineerId) {
                        this.currentMainEngineer = _.find(res, ['id', this.currentMainEngineerId]) || {}
                    } else {
                        this.currentMainEngineer = {}
                    }
                    if (this.currentAssistEngineerId) {
                        this.currentAssistEngineer = _.find(res, ['id', this.currentAssistEngineerId]) || {}
                    } else {
                        this.currentAssistEngineer = {}
                    }
                })
            },
            getCustomerDetail() {
                customerDetail(this.woData.customer)
                    .then(res => {
                        this.currentCustomer = res.payload
                    })
            },
            // 获取设备信息
            getDeviceInfo(root_sn) {
                getDeviceInfo(root_sn, false, false, true).then(res => {
                    this.deviceInfo = res
                    if (this.woData.type == WO_TYPE_EQUIPMENT_MAINTENANCE) {
                        this.maintainOptions = this.deviceInfo.repairs.filter(item => item.name == this.woData
                            .maintain_name)
                    } else {
                        this.maintainOptions = []
                    }
                })
            },
            // 获取签到记录
            getCheckin() {
                // 只取一个最新的签到记录
                checkin({
                    work_order: this.woData.id,
                    page_size: 1,
                    page: 1,
                    ordering: '-check_in_time',
                }).then(res => {
                    const checkin = _.get(res, 'payload.results', [])
                    this.checkins = checkin
                    this.$emit('checkinLoaded', checkin)
                    if (checkin.length) {
                        this.checkin = checkin[0]
                    } else {
                        this.checkin = {}
                    }
                    // console.log(this.checkin)
                })
            },
            // 清空签到记录
            clearCheckin(engineerId) {
                this.checkins.forEach(checkin => {
                    if (engineerId && checkin.engineer != engineerId) return
                    deleteCheckin(checkin.id)
                })
                this.checkins = []
                this.checkin = {}
            },
            // 获取施工现场
            getWorkSite() {
                getSiteRecord({
                    work_order: this.woData.id,
                    page_size: 0,
                    ordering: '-created_at',
                }).then(res => {
                    this.workSite = []
                    let ws = []
                    for (let i = 0; i < res.payload.length; i++) {
                        const attachment = res.payload[i].attachment.map((item) => {
                            return {
                                ...item,
                                content: res.payload[i].content
                            }
                        })
                        ws = _.concat(ws, attachment)
                    }
                    this.workSite = ws
                })
            },
            // 编辑工单字段
            editField(e, fieldName) {
                const form = {
                    id: this.woData.id,
                }
                form[fieldName] = e
                // 如果修改客户，清空设备（设备是关联在客户下的，如果重新改客户，要重新选设备）
                if (fieldName === 'customer' && e != this.woData.customer) {
                    form['device_root_sn'] = null
                    form['device_name'] = null
                    this.deviceInfo = {}
                    this.deviceRootSn = null
                    form['customer_contact'] = null
                }
                if (fieldName === 'maintain_name') {
                    form['save_maintain_item_ids'] = []
                }
                this.edit(form)
            },
            // 修改工单内容
            editContent(params) {
                const form = {
                    id: this.woData.id,
                    content: params.content,
                    save_maintain_item_ids: params.maintain_items
                }
                this.edit(form)
            },
            // 修改设备
            editDevice(root_sn, {
                device_name,
                device_id
            }) {
                const form = {
                    id: this.woData.id,
                    device_root_sn: root_sn,
                    device_name: device_name,
                    device_id: device_id,
                }
                this.edit(form)
            },
            // 工单附件修改
            attachmentChange(ids) {
                const form = {
                    id: this.woData.id,
                    attachment: ids
                }
                this.edit(form)
            },
            // 现场签到修改
            checkInChange(ids) {
                // 有签到记录就修改已有的签到记录，没有就新建一条签到记录
                if (this.checkin && Object.keys(this.checkin).length) {
                    this.checkin.attachment = ids
                    editCheckin(this.checkin).then(() => {
                        this.$emit('refresh')
                    })
                } else {
                    const param = {
                        work_order: this.woData.id,
                        attachment: ids,
                        is_checkin: true
                    }
                    addCheckin(param).then(() => {
                        this.$emit('refresh')
                    })
                }
            },
            // 打开新增施工现场modal
            openAddWorkSiteModal() {
                this.$refs.addWorkSite.open()
            },
            // 施工现场修改
            workSiteChange() {
                this.$emit('refresh')
            },
            // 提交评价
            submitFeedback() {
                if (!this.feedBackForm.quality) {
                    this.$message.error(this.$t('page.quality_required'))
                    return
                }
                if (!this.feedBackForm.attitude) {
                    this.$message.error(this.$t('page.attitude_required'))
                    return
                }
                if (!this.feedBackForm.response_speed) {
                    this.$message.error(this.$t('page.response_speed_required'))
                    return
                }
                createCustomerFeedback(this.feedBackForm).then(() => {
                    this.$message.success(this.$t('base.submit_success'))
                    this.$emit('refresh')
                })
            },
            edit(params, go_back_list, reload = false) {
                editWorkOrder(params).then(res => {
                    console.log(res)
                    if (go_back_list) {
                        setTimeout(() => {
                            this.$router.push('/work-order')
                        }, 1000);
                    }
                    if (reload) {
                        window.location.reload()
                        return
                    }
                    this.$emit('refresh')
                })
            },
            getAuditingEngineer() {
                let params = {
                    type: 'sale',
                    page_size: 0,
                    province: this.woData.province || 1
                }
                auditingEngineer(params).then(res => {
                    this.auditingEngineerList = res.payload
                    console.log(res, this.auditingAssignList)
                })
            },
            getAuditingList() {
                let params = {
                    history_id: this.woData.id,
                    customer: this.woData.customer,
                    page_size: 0
                }
                auditingList(params).then(res => {
                    console.log(res)
                    this.auditingHistory = res.payload
                })
            },
            postAuditingConverts() {
                this.$refs.deviceinfo.postAuditingConverts();
            },
            // 获取服务进度右侧附件，包含签到图片、相关附件、客户签名
            getAuditingAttachment() {
                let woDataId = this.woData.id
                let detailId = this.contactTabid
                if (!woDataId || !detailId) return

                auditingAttachment(woDataId, detailId).then(res => {
                    console.log(res)
                    if (res.payload) {
                        this.auditingAttachmentList = res.payload
                    }
                })
            },
            refresh() {
                this.$emit('refresh')
            },
            tabStatusChange(val) {
                this.$emit('tabStatusChange', val)
            },

            // 联系人tab change
            tabIdChange(val) {
                if (!val) return
                this.contactTabid = val
                this.getAuditingLogs()
                this.getAuditingAttachment()
            },
        },
        components: {
            SwiperTool,
            SetCompanyModal,
            setEngineerModal,
            BusinessCard,
            DeviceInfo,
            ReportList,
        },
        watch: {
            tabStatus:{
                immediate: true,
                handler(val) {
                    this.tabStatus_ = val
                } 
            },
            woData: {
                immediate: true,
                deep: true,
                handler(val) {
                    this.currentCompanyId = val.service_company
                    this.currentMainEngineerId = val.main_engineer
                    this.currentAssistEngineerId = val.assist_engineer
                    this.remark = val.remark
                    this.getCompany()
                    this.getEngineer(this.currentCompanyId)
                    // this.getCustomerDetail()
                    this.getCheckin()
                    this.getWorkSite()
                    if (val.id) {
                        this.getAuditingEngineer()
                        this.getAuditingList()
                        this.getCompanyEngineers()
                        // 联系人tab change
                        this.tabIdChange(this.contactTabid)
                    }
                    const root_sn = _.get(val, 'device_root_sn')
                    this.deviceRootSn = root_sn
                    // console.log('woData变化：', val, root_sn)
                    if (root_sn) {
                        this.getDeviceInfo(root_sn)
                    }
                    if (val.customer_contact) {
                        // 获取联系人详情
                        getCustomerContactDetail(val.customer_contact).then(res => {
                            this.customerContact = res.payload
                        })
                    }
                    if (val.feedback) {
                        this.feedBackForm = {
                            ...val.feedback,
                            work_order: val.id
                        }
                    }
                }
            },
            checkTabVal: {
                immediate: true,
                handler(val) {
                    this.$emit('pageNavTabChange', val)
                }
            }
        }
    }
</script>
<template>
    <b-row align-v="stretch">
        <b-col :cols="checkTabVal == '3'?12:9">
            <!-- nav -->
            <b-card style="box-shadow:none;padding:0" class="auditing-card">
                <b-card-header style="padding:0">
                    <ul class="nav nav-tabs border-bottom-0" role="tablist">
                        <li class="nav-item" v-for="(item, index) in tabOptions" :key="index"
                            @click="checkTabVal = item.value">
                            <b-link style="width:275px"
                                class="nav-link fw-semibold d-flex justify-content-center align-items-center fs-16"
                                :class="item.value == checkTabVal ? 'active' : ''" role="tab">
                                <svg class="me-2" v-if="index===0" xmlns="http://www.w3.org/2000/svg" width="33"
                                    height="32" viewBox="0 0 33 32" fill="none">
                                    <ellipse cx="16.8691" cy="16" rx="15.8848" ry="16" fill="#405189"
                                        fill-opacity="0.176471" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M16.9557 24.1758L10.0133 20.5254L12.9589 18.9758L16.8133 21.0038C16.8717 21.0342 16.9357 21.0494 16.9997 21.0494C17.0637 21.0494 17.1277 21.0342 17.1853 21.0038L21.0389 18.9758L23.9813 20.5238L16.9557 24.1758ZM24.7824 21.0094C24.9152 20.9398 24.9984 20.803 24.9984 20.6542V20.3958C24.9984 20.2478 24.916 20.111 24.784 20.0422L21.8992 18.5246L24.5344 17.1382L24.7832 17.0086C24.916 16.9398 24.9992 16.803 24.9992 16.6534V16.395C24.9992 16.2502 24.92 16.1166 24.7936 16.0454L23.1816 15.1502L22.7928 15.8494L23.9944 16.5166L16.9576 20.1758L13.0216 18.1054L12.9944 18.0542L12.9584 18.0726L10.0056 16.5198L10.912 16.0206L10.5264 15.3198L9.2072 16.0446C9.08 16.115 9.0008 16.2494 9.0008 16.395V16.6526C9.0008 16.8006 9.0824 16.9374 9.2144 17.0062L12.1 18.5246L9.2136 20.0422C9.0816 20.111 9 20.2478 9 20.3958V20.6534C9 20.8014 9.0816 20.9382 9.2136 21.007L16.8128 25.0046C16.8712 25.035 16.9352 25.0502 16.9992 25.0502C17.0632 25.0502 17.1272 25.035 17.1848 25.0046L24.5976 21.1054L24.7824 21.0094ZM17.0004 8.85176L23.9828 12.5254L16.958 16.1774L10.0156 12.5262L17.0004 8.85176ZM9.21594 13.0086L16.8143 17.0054C16.8727 17.0366 16.9367 17.0518 17.0007 17.0518C17.0647 17.0518 17.1287 17.0366 17.1863 17.0054L24.6559 13.0766L24.7839 13.0102C24.9167 12.9414 24.9999 12.8046 24.9999 12.655V12.3974C24.9999 12.2486 24.9175 12.1126 24.7855 12.043L17.1863 8.0462C17.0711 7.9846 16.9303 7.9846 16.8143 8.0462L9.21594 12.043C9.08394 12.1126 9.00234 12.2486 9.00234 12.3974V12.6542C9.00234 12.803 9.08394 12.939 9.21594 13.0086Z"
                                        fill="#405189" />
                                </svg>
                                <svg class="me-2" v-else-if="index===1" xmlns="http://www.w3.org/2000/svg" width="32"
                                    height="32" viewBox="0 0 32 32" fill="none">
                                    <circle cx="16" cy="16" r="16" fill="#405189" fill-opacity="0.176471" />
                                    <path
                                        d="M18.3638 18.1332C18.2482 18.1332 18.1615 18.0754 18.0748 18.0176L16.7164 16.6592C16.6297 16.5725 16.6008 16.4858 16.6008 16.3702C16.6008 16.2546 16.6586 16.1679 16.7164 16.0812L17.2367 15.5609C17.2945 15.4742 17.4101 15.4453 17.5257 15.4453C17.6413 15.4453 17.728 15.5031 17.8147 15.5609L19.1731 16.9193C19.2598 17.006 19.2887 17.0927 19.2887 17.2083C19.2887 17.3239 19.2309 17.4106 19.1731 17.4973L18.6528 18.0176C18.5661 18.0754 18.4505 18.1332 18.3638 18.1332ZM17.4968 15.5031C17.4101 15.5031 17.3234 15.532 17.2945 15.5898L16.7742 16.1101C16.7164 16.1679 16.6875 16.2546 16.6875 16.3413C16.6875 16.428 16.7164 16.5147 16.7742 16.5725L18.1326 17.9309C18.2482 18.0465 18.4794 18.0465 18.595 17.9309L19.1153 17.4106C19.1731 17.3528 19.202 17.2661 19.202 17.1794C19.202 17.0927 19.1731 17.006 19.1153 16.9482L17.7569 15.5898C17.6991 15.532 17.6124 15.5031 17.4968 15.5031C17.5257 15.5031 17.5257 15.5031 17.4968 15.5031ZM18.3349 17.7575L16.9187 16.3413L17.4968 15.7632L18.913 17.1794L18.3349 17.7575ZM17.0343 16.3413L18.3349 17.6418L18.7974 17.1794L17.4968 15.8788L17.0343 16.3413ZM14.6066 16.8037C14.5488 16.8037 14.491 16.8326 14.4332 16.8904C14.3465 16.9771 14.3465 17.1505 14.4332 17.2372C14.491 17.295 14.5488 17.295 14.6066 17.295C14.6644 17.295 14.7222 17.2661 14.78 17.2083C14.8667 17.1216 14.8667 16.9482 14.78 16.8615C14.7511 16.8326 14.6933 16.8037 14.6066 16.8037ZM14.6933 17.1216C14.6644 17.1505 14.6644 17.1505 14.6355 17.1505C14.6066 17.1505 14.5777 17.1505 14.5777 17.1216C14.5488 17.0927 14.5488 17.0349 14.5777 16.9771C14.6066 16.9482 14.6066 16.9482 14.6355 16.9482C14.6644 16.9482 14.6933 16.9482 14.6933 16.9771C14.7222 17.0349 14.7222 17.0927 14.6933 17.1216Z"
                                        fill="#405189" />
                                    <path
                                        d="M14.6357 17.3534C14.549 17.3534 14.4912 17.3245 14.4334 17.2667C14.3178 17.1511 14.3178 16.9777 14.4334 16.8621C14.4912 16.8043 14.549 16.7754 14.6357 16.7754C14.7224 16.7754 14.7802 16.8043 14.838 16.8621C14.9536 16.9777 14.9536 17.1511 14.838 17.2667C14.7802 17.3245 14.6935 17.3534 14.6357 17.3534ZM14.6068 16.8621C14.549 16.8621 14.4912 16.891 14.4623 16.9199C14.3756 17.0066 14.3756 17.1222 14.4623 17.2089C14.4912 17.2378 14.549 17.2667 14.6068 17.2667C14.6646 17.2667 14.7224 17.2378 14.7513 17.2089C14.838 17.1222 14.838 17.0066 14.7513 16.9199C14.7224 16.8621 14.6646 16.8621 14.6068 16.8621ZM14.6068 17.2089C14.5779 17.2089 14.549 17.2089 14.5201 17.18C14.4623 17.1222 14.4623 17.0355 14.5201 16.9777C14.5779 16.9199 14.6646 16.9199 14.7224 16.9777C14.7802 17.0355 14.7802 17.1222 14.7224 17.18C14.6935 17.18 14.6646 17.2089 14.6068 17.2089ZM14.6068 17.0066C14.6068 17.0066 14.5779 17.0066 14.5779 17.0355C14.549 17.0644 14.549 17.0933 14.5779 17.1222C14.6068 17.1511 14.6357 17.1511 14.6646 17.1222C14.6935 17.0933 14.6935 17.0644 14.6646 17.0355C14.6357 17.0066 14.6357 17.0066 14.6068 17.0066Z"
                                        fill="#405189" />
                                    <path
                                        d="M14.6066 17.3245C14.5488 17.3245 14.491 17.2956 14.4332 17.2378C14.3465 17.1511 14.3465 16.9777 14.4332 16.8621C14.491 16.8043 14.5488 16.7754 14.6066 16.7754C14.6644 16.7754 14.7511 16.8043 14.78 16.8621C14.8667 16.9488 14.8667 17.1222 14.78 17.2378C14.7511 17.2956 14.6933 17.3245 14.6066 17.3245ZM14.6066 16.8332C14.5488 16.8332 14.491 16.8621 14.4332 16.891C14.3465 16.9777 14.3465 17.1222 14.4332 17.2089C14.491 17.2667 14.5488 17.2667 14.6066 17.2667C14.6644 17.2667 14.7222 17.2378 14.78 17.2089C14.8667 17.1222 14.8667 16.9777 14.78 16.891C14.7222 16.8621 14.6933 16.8332 14.6066 16.8332ZM14.6066 17.18C14.5777 17.18 14.5488 17.18 14.5488 17.1511C14.5199 17.1222 14.5199 17.0355 14.5488 17.0066C14.5777 16.9777 14.6066 16.9777 14.6355 16.9777C14.6644 16.9777 14.6933 16.9777 14.6933 17.0066C14.7222 17.0355 14.7222 17.1222 14.6933 17.1511C14.6644 17.1511 14.6355 17.18 14.6066 17.18ZM14.6066 16.9777C14.5777 16.9777 14.5777 16.9777 14.5488 17.0066C14.5199 17.0355 14.5199 17.0933 14.5488 17.1222C14.5777 17.1511 14.5777 17.1511 14.6066 17.1511C14.6355 17.1511 14.6355 17.1511 14.6644 17.1222C14.6933 17.0933 14.6933 17.0355 14.6644 17.0066C14.6644 16.9777 14.6355 16.9777 14.6066 16.9777Z"
                                        fill="#405189" />
                                    <path
                                        d="M14.6357 17.3534C14.549 17.3534 14.4912 17.3245 14.4334 17.2667C14.3178 17.1511 14.3178 16.9777 14.4334 16.8621C14.4912 16.8043 14.5779 16.7754 14.6357 16.7754C14.7224 16.7754 14.7802 16.8043 14.838 16.8621C14.9536 16.9777 14.9536 17.1511 14.838 17.2667C14.7802 17.3245 14.6935 17.3534 14.6357 17.3534ZM14.6068 16.8332C14.549 16.8621 14.5201 16.891 14.4623 16.9199C14.3756 17.0066 14.4045 17.1222 14.4623 17.2089C14.4912 17.2378 14.549 17.2667 14.6068 17.2667C14.6646 17.2667 14.6935 17.2378 14.7513 17.2089C14.838 17.1222 14.8091 17.0066 14.7513 16.9199C14.7224 16.891 14.6646 16.8621 14.6068 16.8332ZM14.6068 17.2089C14.5779 17.2089 14.5201 17.18 14.4912 17.18C14.4334 17.1222 14.4334 17.0355 14.4912 16.9777C14.549 16.9199 14.6357 16.9199 14.6935 16.9777C14.7513 17.0355 14.7513 17.1222 14.6935 17.18C14.6935 17.18 14.6646 17.2089 14.6068 17.2089ZM14.6068 17.0066C14.549 17.0355 14.549 17.0644 14.5779 17.0933C14.5779 17.0933 14.6068 17.1222 14.6357 17.0933C14.6646 17.0644 14.6646 17.0355 14.6357 17.0355C14.6357 17.0066 14.6357 17.0066 14.6068 17.0066Z"
                                        fill="#405189" />
                                    <path
                                        d="M19.4045 12.901C19.3756 12.8432 19.3467 12.8143 19.2889 12.8143H19.2599C19.231 12.8143 19.1732 12.8432 19.1443 12.8721L18.364 13.6814L17.8149 13.1322L18.5952 12.323C18.6241 12.2941 18.653 12.2363 18.6241 12.1785C18.6241 12.1207 18.5663 12.0918 18.5374 12.0629C18.3351 11.9762 18.1617 11.9473 17.9594 11.9473C17.5547 11.9473 17.1501 12.1207 16.8611 12.4386C16.601 12.6987 16.4565 13.0744 16.4276 13.4502C16.3987 13.7681 16.4565 14.0282 16.601 14.3172L13.8842 16.6293C13.653 16.8606 13.653 17.2363 13.8842 17.4675L14.2021 17.7854C14.3178 17.901 14.4623 17.9588 14.6068 17.9588C14.7513 17.9588 14.9247 17.901 15.0114 17.7854L17.3813 15.0108C17.5836 15.0976 17.7282 15.1265 17.9594 15.1265C18.364 15.1265 18.7686 14.953 19.0287 14.664C19.2599 14.4328 19.3756 14.1438 19.4334 13.8259C19.549 13.4791 19.5201 13.19 19.4045 12.901ZM18.0172 14.7796C17.8149 14.7796 17.6704 14.7507 17.4969 14.664C17.468 14.664 17.4391 14.6351 17.4102 14.6351C17.3524 14.6351 17.3235 14.664 17.2946 14.6929L14.838 17.5542C14.7802 17.612 14.7224 17.6409 14.6646 17.6409C14.6068 17.6409 14.5201 17.612 14.4623 17.5542L14.1443 17.2363C14.0287 17.1207 14.0287 16.9473 14.1443 16.8606L16.9478 14.4617C17.0056 14.4039 17.0056 14.3172 16.9767 14.2594C16.601 13.7681 16.6877 13.1322 17.1212 12.6698C17.3524 12.4386 17.6415 12.2941 17.9883 12.2941C18.075 12.2941 18.1328 12.2941 18.2195 12.323L17.5258 13.0455C17.468 13.1033 17.468 13.2189 17.5258 13.2767L18.3062 14.0282C18.3351 14.0571 18.364 14.086 18.4218 14.086C18.4507 14.086 18.5085 14.0571 18.5374 14.0282L19.231 13.3056C19.3178 13.7103 19.2021 14.1438 18.9131 14.4328C18.653 14.6351 18.3351 14.7796 18.0172 14.7796Z"
                                        fill="#405189" />
                                    <path
                                        d="M16.6296 16.3413C16.6296 16.428 16.6585 16.5436 16.7452 16.6014L18.1036 17.9598C18.1614 18.0176 18.277 18.0754 18.3637 18.0754C18.4504 18.0754 18.5661 18.0465 18.6239 17.9598L19.1441 17.4395C19.2019 17.3817 19.2597 17.2661 19.2597 17.1794C19.2597 17.0927 19.2308 16.9771 19.1441 16.9193L17.7857 15.5609C17.7279 15.5031 17.6123 15.4453 17.5256 15.4453C17.4389 15.4453 17.3233 15.4742 17.2655 15.5609L16.7452 16.0812C16.6585 16.1679 16.6296 16.2546 16.6296 16.3413ZM16.9765 16.3413L17.4967 15.821L18.8551 17.1794L18.3348 17.6996L16.9765 16.3413Z"
                                        fill="#405189" />
                                    <path
                                        d="M14.6349 17.9893C14.4615 17.9893 14.317 17.9315 14.2014 17.8159L13.8835 17.4691C13.6523 17.2378 13.6234 16.8332 13.8835 16.5731L16.5714 14.2899C16.4269 14.0587 16.3691 13.7985 16.398 13.4517C16.4269 13.076 16.5714 12.7003 16.8315 12.4113C17.1205 12.0933 17.5251 11.9199 17.9586 11.9199H17.9876C18.1899 11.9199 18.3922 11.9488 18.5656 12.0355C18.6234 12.0644 18.6812 12.1222 18.6812 12.18C18.6812 12.2378 18.6812 12.3245 18.6234 12.3534L17.8719 13.1338L18.3633 13.6251L19.1147 12.8448C19.1725 12.787 19.2303 12.787 19.2881 12.787C19.3459 12.787 19.4037 12.8448 19.4326 12.9026C19.5482 13.1916 19.606 13.5095 19.5482 13.8274C19.4904 14.1454 19.3459 14.4344 19.1147 14.6656C18.8257 14.9835 18.4211 15.1569 18.0165 15.1569C17.7852 15.1569 17.6407 15.1569 17.4384 15.0702L15.0974 17.8159C14.9818 17.9315 14.8084 17.9893 14.6349 17.9893ZM13.9124 16.602L13.9413 16.6309C13.739 16.8621 13.739 17.2089 13.9413 17.4113L14.2592 17.7581C14.3748 17.8448 14.4904 17.9026 14.6349 17.9026C14.7795 17.9026 14.924 17.8448 15.0107 17.7292L17.4095 14.9257H17.4384C17.6407 15.0124 17.7852 15.0413 17.9876 15.0124C18.3922 15.0124 18.7679 14.839 19.028 14.55C19.2303 14.3188 19.3748 14.0587 19.4326 13.7407C19.4904 13.4517 19.4615 13.1338 19.317 12.8737C19.2881 12.8448 19.2592 12.8159 19.2303 12.8159C19.2014 12.8159 19.1436 12.8159 19.1147 12.8448L18.3055 13.6829L17.6985 13.076L18.5078 12.2378C18.5367 12.2089 18.5367 12.18 18.5367 12.1222C18.5367 12.0933 18.5078 12.0644 18.4789 12.0355C18.3055 11.9488 18.1032 11.9199 17.9008 11.9199C17.4962 11.9199 17.1205 12.0933 16.8315 12.3823C16.5714 12.6425 16.4269 12.9893 16.398 13.365C16.3691 13.7118 16.4269 13.9719 16.5714 14.2032L16.6003 14.2321L16.5714 14.261L13.8546 16.5731L13.9124 16.602ZM14.6349 17.6714C14.5482 17.6714 14.4904 17.6425 14.4326 17.5847L14.1147 17.2667C13.9991 17.1511 13.9991 16.9488 14.1147 16.8332L16.9182 14.4344C16.976 14.4055 16.976 14.3188 16.9471 14.261C16.5714 13.7696 16.6292 13.1049 17.0916 12.6425C17.3228 12.3823 17.6407 12.2667 17.9876 12.2378C18.0743 12.2378 18.161 12.2378 18.2188 12.2667H18.3055L17.554 13.0471C17.4962 13.1049 17.4962 13.1627 17.554 13.2205L18.3344 13.9719C18.3633 14.0008 18.3922 14.0008 18.4211 14.0008C18.45 14.0008 18.4789 14.0008 18.5078 13.9719L19.2592 13.1916L19.2881 13.2783C19.3748 13.7118 19.2592 14.1454 18.9702 14.4633C18.739 14.6945 18.45 14.839 18.1321 14.839H18.1032C17.9008 14.839 17.7563 14.8101 17.554 14.7234C17.5251 14.6945 17.4384 14.6945 17.4095 14.7523L14.9529 17.6136C14.8084 17.6425 14.7217 17.6714 14.6349 17.6714ZM17.9876 12.2956C17.6407 12.2956 17.3517 12.4402 17.1205 12.6714C16.687 13.1338 16.6292 13.7407 16.976 14.2032C17.0338 14.2899 17.0338 14.4055 16.9471 14.4633L14.1436 16.8621C14.0569 16.9488 14.0569 17.0933 14.1436 17.18L14.4615 17.5269C14.4904 17.5558 14.5482 17.5847 14.606 17.5847C14.6639 17.5847 14.7217 17.5558 14.7506 17.5269L17.2072 14.6656C17.265 14.6078 17.3806 14.5789 17.4673 14.6078C17.6407 14.6945 17.7563 14.7234 17.9297 14.7234H17.9586C18.2766 14.7234 18.5656 14.5789 18.7968 14.3477C19.0569 14.0876 19.1725 13.6829 19.1147 13.3361L18.4789 14.0008C18.45 14.0297 18.3922 14.0587 18.3344 14.0587C18.2766 14.0587 18.2477 14.0297 18.1899 14.0008L17.4095 13.2494C17.3228 13.1627 17.3228 13.0471 17.4095 12.9604L18.0454 12.2956H17.9876Z"
                                        fill="#405189" />
                                    <path
                                        d="M14.2014 13.9724H14.5771L15.4442 14.8106C15.4731 14.8395 15.502 14.8684 15.5598 14.8684C15.5887 14.8684 15.6465 14.8395 15.6754 14.8106C15.7332 14.7528 15.7332 14.6371 15.6754 14.5793L14.7505 13.6834C14.7216 13.6545 14.6927 13.6256 14.6349 13.6256H14.2881L13.8835 12.9897L14.1147 12.7585L14.7794 13.1632V13.51C14.7794 13.5389 14.8083 13.5967 14.8372 13.6256L15.791 14.5504C15.8199 14.5793 15.8488 14.6082 15.9066 14.6082C15.9355 14.6082 15.9933 14.5793 16.0222 14.5504C16.08 14.4926 16.08 14.377 16.0222 14.3192L15.0684 13.4233V13.0476C15.0684 12.9897 15.0395 12.9319 14.9817 12.903L14.1436 12.4117C14.1147 12.3828 14.0858 12.3828 14.0569 12.3828C14.028 12.3828 13.9702 12.4117 13.9413 12.4406L13.5367 12.8741C13.4789 12.9319 13.4789 13.0187 13.5078 13.0765L14.028 13.8857C14.0858 13.9435 14.1436 13.9724 14.2014 13.9724Z"
                                        fill="#405189" />
                                    <path
                                        d="M20.7052 11.052V16.9191C20.7052 17.2659 20.9942 17.5549 21.341 17.5549H22.7861C22.8728 17.5549 22.9306 17.6127 22.9306 17.6994V18.6532H10.0983V17.6994C10.0983 17.6127 10.1561 17.5549 10.2428 17.5549H11.6879C12.0347 17.5549 12.3237 17.2659 12.3237 16.9191V16.1965L12.2948 12.2948L12.3237 11.8324V11.052H20.7052ZM12.3237 10.4162V9.66474C12.3237 9.31792 12.0347 9.0289 11.6879 9.0289H10.763C10.4162 9.0289 10.1272 9.31792 10.1272 9.66474V17.0636C9.80925 17.1214 9.57803 17.4104 9.57803 17.7283V18.711C9.23121 18.7977 9 19.0578 9 19.3757V21.948C9 22.1214 9.0578 22.2948 9.20231 22.4104C9.28902 22.526 9.43353 22.5838 9.57803 22.6127H23.3353C23.711 22.6127 24 22.3237 24 21.948V19.3757C24 19.0578 23.7688 18.7688 23.4509 18.7399V17.7572C23.4509 17.4104 23.2197 17.1503 22.9017 17.0925V9.66474C22.9017 9.49133 22.8439 9.31792 22.6994 9.20231C22.5838 9.08671 22.4104 9 22.237 9H21.3121C20.9653 9 20.6763 9.28902 20.6763 9.63584V10.3873H12.3237V10.4162ZM22.237 17.0636H21.3988C21.341 17.0636 21.2832 17.0058 21.2832 16.948V9.66474C21.2832 9.60694 21.3121 9.57803 21.3699 9.57803H22.2948C22.3237 9.57803 22.3526 9.57803 22.3526 9.60694C22.3815 9.63584 22.3815 9.63584 22.3815 9.66474V16.9191C22.3815 17.0058 22.3237 17.0636 22.237 17.0636ZM10.6763 9.66474C10.6763 9.60694 10.7052 9.57803 10.763 9.57803H11.6879C11.7457 9.57803 11.7746 9.60694 11.7746 9.66474V16.9191C11.7746 16.9769 11.7168 17.0347 11.659 17.0347H10.8208C10.7341 17.0347 10.6474 16.948 10.6474 16.8613V9.66474H10.6763ZM23.4798 21.948C23.4798 22.0058 23.422 22.0636 23.3642 22.0636H9.66474C9.60694 22.0636 9.54913 22.0058 9.54913 21.948V19.3757C9.54913 19.3179 9.60694 19.2601 9.66474 19.2601H23.3642C23.422 19.2601 23.4798 19.3179 23.4798 19.3757V21.948Z"
                                        fill="#405189" />
                                </svg>
                                <svg class="me-2" v-else xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                                    viewBox="0 0 32 32" fill="none">
                                    <circle cx="16" cy="16" r="16" fill="#405189" fill-opacity="0.176471" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M9 9.25V23.5H9.5V9.5H21.5V21H22V9.25C22 9.1 21.9 9 21.75 9H9.25C9.1 9 9 9.1 9 9.25ZM23.5 22.2501V23.5001C23.5 24.3501 22.85 25.0001 22 25.0001H10.5C9.65 25.0001 9 24.3501 9 23.5001H9.5C9.5 24.0501 9.95 24.5001 10.5 24.5001C11.05 24.5001 11.5 24.0501 11.5 23.5001V22.2501C11.5 22.1001 11.6 22.0001 11.75 22.0001H23.25C23.4 22.0001 23.5 22.1001 23.5 22.2501ZM11.9993 23.4999V22.4999H22.9993V23.4999C22.9993 24.0499 22.5493 24.4999 21.9993 24.4999H11.5993C11.8493 24.2499 11.9993 23.8999 11.9993 23.4999ZM11.4993 12.5H18.4993V13H11.4993V12.5ZM19.4993 14.9999H11.4993V15.4999H19.4993V14.9999ZM11.4993 17.5001H18.4993V18.0001H11.4993V17.5001Z"
                                        fill="#405189" />
                                    <path
                                        d="M9 23.5H8.85V23.65H9V23.5ZM9.5 23.5V23.65H9.65V23.5H9.5ZM9.5 9.5V9.35H9.35V9.5H9.5ZM21.5 9.5H21.65V9.35H21.5V9.5ZM21.5 21H21.35V21.15H21.5V21ZM22 21V21.15H22.15V21H22ZM9 23.5001V23.3501H8.85V23.5001H9ZM9.5 23.5001H9.65V23.3501H9.5V23.5001ZM11.9993 22.4999V22.3499H11.8493V22.4999H11.9993ZM22.9993 22.4999H23.1493V22.3499H22.9993V22.4999ZM11.5993 24.4999L11.4932 24.3939L11.2371 24.6499H11.5993V24.4999ZM18.4993 12.5H18.6493V12.35H18.4993V12.5ZM11.4993 12.5V12.35H11.3493V12.5H11.4993ZM18.4993 13V13.15H18.6493V13H18.4993ZM11.4993 13H11.3493V13.15H11.4993V13ZM11.4993 14.9999V14.8499H11.3493V14.9999H11.4993ZM19.4993 14.9999H19.6493V14.8499H19.4993V14.9999ZM11.4993 15.4999H11.3493V15.6499H11.4993V15.4999ZM19.4993 15.4999V15.6499H19.6493V15.4999H19.4993ZM18.4993 17.5001H18.6493V17.3501H18.4993V17.5001ZM11.4993 17.5001V17.3501H11.3493V17.5001H11.4993ZM18.4993 18.0001V18.1501H18.6493V18.0001H18.4993ZM11.4993 18.0001H11.3493V18.1501H11.4993V18.0001ZM9.15 23.5V9.25H8.85V23.5H9.15ZM9.5 23.35H9V23.65H9.5V23.35ZM9.35 9.5V23.5H9.65V9.5H9.35ZM21.5 9.35H9.5V9.65H21.5V9.35ZM21.65 21V9.5H21.35V21H21.65ZM22 20.85H21.5V21.15H22V20.85ZM21.85 9.25V21H22.15V9.25H21.85ZM21.75 9.15C21.7909 9.15 21.8134 9.16298 21.8252 9.17482C21.837 9.18665 21.85 9.20909 21.85 9.25H22.15C22.15 9.14091 22.113 9.03835 22.0373 8.96268C21.9616 8.88702 21.8591 8.85 21.75 8.85V9.15ZM9.25 9.15H21.75V8.85H9.25V9.15ZM9.15 9.25C9.15 9.20909 9.16298 9.18665 9.17482 9.17482C9.18665 9.16298 9.20909 9.15 9.25 9.15V8.85C9.14091 8.85 9.03835 8.88702 8.96268 8.96268C8.88702 9.03835 8.85 9.14091 8.85 9.25H9.15ZM23.65 23.5001V22.2501H23.35V23.5001H23.65ZM22 25.1501C22.9328 25.1501 23.65 24.433 23.65 23.5001H23.35C23.35 24.2673 22.7672 24.8501 22 24.8501V25.1501ZM10.5 25.1501H22V24.8501H10.5V25.1501ZM8.85 23.5001C8.85 24.433 9.56716 25.1501 10.5 25.1501V24.8501C9.73284 24.8501 9.15 24.2673 9.15 23.5001H8.85ZM9.5 23.3501H9V23.6501H9.5V23.3501ZM10.5 24.3501C10.0328 24.3501 9.65 23.9673 9.65 23.5001H9.35C9.35 24.133 9.86716 24.6501 10.5 24.6501V24.3501ZM11.35 23.5001C11.35 23.9673 10.9672 24.3501 10.5 24.3501V24.6501C11.1328 24.6501 11.65 24.133 11.65 23.5001H11.35ZM11.35 22.2501V23.5001H11.65V22.2501H11.35ZM11.75 21.8501C11.6409 21.8501 11.5384 21.8871 11.4627 21.9628C11.387 22.0385 11.35 22.141 11.35 22.2501H11.65C11.65 22.2092 11.663 22.1868 11.6748 22.1749C11.6866 22.1631 11.7091 22.1501 11.75 22.1501V21.8501ZM23.25 21.8501H11.75V22.1501H23.25V21.8501ZM23.65 22.2501C23.65 22.141 23.613 22.0385 23.5373 21.9628C23.4616 21.8871 23.3591 21.8501 23.25 21.8501V22.1501C23.2909 22.1501 23.3134 22.1631 23.3252 22.1749C23.337 22.1868 23.35 22.2092 23.35 22.2501H23.65ZM11.8493 22.4999V23.4999H12.1493V22.4999H11.8493ZM22.9993 22.3499H11.9993V22.6499H22.9993V22.3499ZM23.1493 23.4999V22.4999H22.8493V23.4999H23.1493ZM21.9993 24.6499C22.6321 24.6499 23.1493 24.1328 23.1493 23.4999H22.8493C22.8493 23.9671 22.4664 24.3499 21.9993 24.3499V24.6499ZM11.5993 24.6499H21.9993V24.3499H11.5993V24.6499ZM11.8493 23.4999C11.8493 23.8614 11.7142 24.1729 11.4932 24.3939L11.7053 24.606C11.9844 24.327 12.1493 23.9385 12.1493 23.4999H11.8493ZM18.4993 12.35H11.4993V12.65H18.4993V12.35ZM18.6493 13V12.5H18.3493V13H18.6493ZM11.4993 13.15H18.4993V12.85H11.4993V13.15ZM11.3493 12.5V13H11.6493V12.5H11.3493ZM11.4993 15.1499H19.4993V14.8499H11.4993V15.1499ZM11.6493 15.4999V14.9999H11.3493V15.4999H11.6493ZM19.4993 15.3499H11.4993V15.6499H19.4993V15.3499ZM19.3493 14.9999V15.4999H19.6493V14.9999H19.3493ZM18.4993 17.3501H11.4993V17.6501H18.4993V17.3501ZM18.6493 18.0001V17.5001H18.3493V18.0001H18.6493ZM11.4993 18.1501H18.4993V17.8501H11.4993V18.1501ZM11.3493 17.5001V18.0001H11.6493V17.5001H11.3493Z"
                                        fill="#405189" />
                                </svg>

                                {{ item.text }}
                            </b-link>
                        </li>
                    </ul>
                </b-card-header>
                <b-card-body style="background: #f3f3f9;padding:0">
                    <!-- 基本信息-上面的信息 -->
                    <div style="background: #ffffff;padding: 20px;font-size: 13px" v-show="checkTabVal == '1'">
                        <b-row cols="4">
                            <b-col class="mt-5">
                                <p class="text-muted mb-2 text-uppercase fw-semibold" style="color: #6A78A3;">{{$t('page.auditing.customer_name')}}</p>
                                <p style="color: #212529;font-size: 13px;font-weight: 500;">{{woData.customer_txt}}</p>
                            </b-col>
                            <b-col class="mt-5">
                                <p class="text-muted mb-2 text-uppercase fw-semibold" style="color: #6A78A3;">{{$t('page.auditing.KA_customer_level')}}</p>
                                <p style="color: #212529;font-size: 13px;font-weight: 500;">{{woData.ka_level_txt}}</p>
                            </b-col>
                            <b-col class="mt-5">
                                <p class="text-muted mb-2 text-uppercase fw-semibold" style="color: #6A78A3;">{{$t('page.auditing.service_type')}}</p>
                                <p style="color: #212529;font-size: 13px;font-weight: 500;">
                                    {{woData.type_txt&&$t(woData.type_txt)||'-'}}</p>
                            </b-col>

                        </b-row>
                        <b-row cols="4">
                            <b-col class="mt-5">
                                <p class="text-muted mb-2 text-uppercase fw-semibold" style="color: #6A78A3;">{{$t('page.auditing.province')}}</p>
                                <p style="color: #212529;font-size: 13px;font-weight: 500;">{{woData.province_txt?$t(`province['${woData.province_txt}']`):'-'}}
                                </p>
                            </b-col>
                            <b-col class="mt-5">
                                <p class="text-muted mb-2 text-uppercase fw-semibold" style="color: #6A78A3;">
                                    {{$t('page.auditing.detailed_address')}}
                                </p>
                                <p style="color: #212529;font-size: 13px;font-weight: 500;">
                                    {{woData.customer_address||'-'}}</p>
                            </b-col>

                        </b-row>
                        <b-row cols="4">
                            <b-col class="mt-5">
                                <p class="text-muted mb-2 text-uppercase fw-semibold">{{$t('page.auditing.latest_completion_time')}}</p>
                                <p style="color: #212529;font-size: 13px;font-weight: 500;">{{woData.deadline||'-'}}</p>
                            </b-col>
                            <b-col class="mt-5">
                                <p class="text-muted mb-2 text-uppercase fw-semibold">{{$t('page.auditing.last_execution_time')}}</p>
                                <p style="color: #212529;font-size: 13px;font-weight: 500;">
                                    {{woData.last_execution_time||'-'}}</p>
                            </b-col>
                        </b-row>
                        <b-row cols="4">
                            <b-col class="mt-5" cols="12">
                                <p class="text-muted mb-2 text-uppercase fw-semibold" style="color: #6A78A3;">{{$t('page.auditing.work_order_notes')}}</p>
                                <el-input v-model="remark" :autosize="{ minRows: 4, maxRows: 4 }" type="textarea"
                                    placeholder="" @change="putAuditingDetails" />
                            </b-col>
                        </b-row>
                    </div>
                    <!-- 服务过程 -->
                    <device-info ref="deviceinfo" v-show="checkTabVal == '2'" :editType="editType" @tabIdChange="tabIdChange"
                        @tabStatusChange="tabStatusChange" @refresh="refresh" v-model:tabStatus="tabStatus_"
                         v-model:checkTabVal="checkTabVal" :woData="woData"
                         />
                         <!-- @deviceLoaded="deviceLoaded" -->
                    <!-- 服务报告 -->
                    <ReportList v-if="checkTabVal == '3'" :wo-id="woData.id" :wo-info="woData" :editType="editType"
                        :auditingAssignList="auditingAssignList" :show-search="false" :show-title="false" />
                </b-card-body>
            </b-card>

            <!-- 基本信息-派工信息 -->
            <b-card v-show="checkTabVal == '1'">
                <b-card-header>
                    <div class="d-flex">
                        <h5 class="card-title flex-grow-1 mb-0 d-flex align-items-center">
                            <svg class="me-2" xmlns="http://www.w3.org/2000/svg" width="23" height="18"
                                viewBox="0 0 23 18" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M12.3333 5.66667V4.33333C12.3333 2.49333 13.8267 1 15.6667 1C17.5067 1 19 2.49333 19 4.33333V5.66667C19 7.50667 17.5067 9 15.6667 9C13.8267 9 12.3333 7.50667 12.3333 5.66667ZM4.33333 6.33333V7.66667C4.33333 9.50667 5.82667 11 7.66667 11C9.50667 11 11 9.50667 11 7.66667V6.33333C11 4.49333 9.50667 3 7.66667 3C5.82667 3 4.33333 4.49333 4.33333 6.33333ZM14.3333 13C14.3333 12.9067 14.2933 12.82 14.2267 12.7533L11.34 10.0933L10.8867 10.58L13.6667 13.1467V16.3333H1.66667V13.1467L4.44667 10.5733L3.99333 10.0867L1.10667 12.7533C1.04 12.82 1 12.9067 1 13V16.6667C1 16.8533 1.14667 17 1.33333 17H14C14.1867 17 14.3333 16.8533 14.3333 16.6667V13ZM5 7.66667C5 9.14001 6.19333 10.3333 7.66667 10.3333C9.14 10.3333 10.3333 9.14001 10.3333 7.66667V6.33334C10.3333 4.86 9.14 3.66667 7.66667 3.66667C6.19333 3.66667 5 4.86 5 6.33334V7.66667ZM19.34 8.08667L22.2267 10.7533C22.2933 10.82 22.3333 10.9067 22.3333 11V14.6667C22.3333 14.8533 22.1867 15 22 15H15.6667V14.3333H21.6667V11.1467L18.8867 8.57334L19.34 8.08667ZM15.6667 8.33334C14.1933 8.33334 13 7.14001 13 5.66667V4.33334C13 2.86 14.1933 1.66667 15.6667 1.66667C17.14 1.66667 18.3333 2.86 18.3333 4.33334V5.66667C18.3333 7.14001 17.14 8.33334 15.6667 8.33334Z"
                                    fill="#6D7080" />
                                <path
                                    d="M14.2267 12.7533L14.4036 12.5764L14.3961 12.5695L14.2267 12.7533ZM11.34 10.0933L11.5094 9.90949L11.3266 9.74099L11.1571 9.92294L11.34 10.0933ZM10.8867 10.58L10.7037 10.4096L10.5326 10.5933L10.7171 10.7637L10.8867 10.58ZM13.6667 13.1467H13.9167V13.0372L13.8363 12.963L13.6667 13.1467ZM13.6667 16.3333V16.5833H13.9167V16.3333H13.6667ZM1.66667 16.3333H1.41667V16.5833H1.66667V16.3333ZM1.66667 13.1467L1.49684 12.9632L1.41667 13.0374V13.1467H1.66667ZM4.44667 10.5733L4.61649 10.7568L4.80053 10.5864L4.6296 10.4029L4.44667 10.5733ZM3.99333 10.0867L4.17626 9.91627L4.00657 9.7341L3.82369 9.90303L3.99333 10.0867ZM1.10667 12.7533L0.936893 12.5696L0.92989 12.5766L1.10667 12.7533ZM22.2267 10.7533L22.4036 10.5764L22.3963 10.5697L22.2267 10.7533ZM19.34 8.08667L19.5096 7.90303L19.3268 7.7341L19.1571 7.91627L19.34 8.08667ZM15.6667 15H15.4167V15.25H15.6667V15ZM15.6667 14.3333V14.0833H15.4167V14.3333H15.6667ZM21.6667 14.3333V14.5833H21.9167V14.3333H21.6667ZM21.6667 11.1467H21.9167V11.0374L21.8365 10.9632L21.6667 11.1467ZM18.8867 8.57334L18.7037 8.40294L18.5328 8.58644L18.7168 8.7568L18.8867 8.57334ZM12.0833 4.33333V5.66667H12.5833V4.33333H12.0833ZM15.6667 0.75C13.6886 0.75 12.0833 2.35526 12.0833 4.33333H12.5833C12.5833 2.6314 13.9647 1.25 15.6667 1.25V0.75ZM19.25 4.33333C19.25 2.35526 17.6447 0.75 15.6667 0.75V1.25C17.3686 1.25 18.75 2.6314 18.75 4.33333H19.25ZM19.25 5.66667V4.33333H18.75V5.66667H19.25ZM15.6667 9.25C17.6447 9.25 19.25 7.64474 19.25 5.66667H18.75C18.75 7.3686 17.3686 8.75 15.6667 8.75V9.25ZM12.0833 5.66667C12.0833 7.64474 13.6886 9.25 15.6667 9.25V8.75C13.9647 8.75 12.5833 7.3686 12.5833 5.66667H12.0833ZM4.58333 7.66667V6.33333H4.08333V7.66667H4.58333ZM7.66667 10.75C5.96474 10.75 4.58333 9.3686 4.58333 7.66667H4.08333C4.08333 9.64474 5.6886 11.25 7.66667 11.25V10.75ZM10.75 7.66667C10.75 9.3686 9.3686 10.75 7.66667 10.75V11.25C9.64474 11.25 11.25 9.64474 11.25 7.66667H10.75ZM10.75 6.33333V7.66667H11.25V6.33333H10.75ZM7.66667 3.25C9.3686 3.25 10.75 4.6314 10.75 6.33333H11.25C11.25 4.35526 9.64474 2.75 7.66667 2.75V3.25ZM4.58333 6.33333C4.58333 4.6314 5.96474 3.25 7.66667 3.25V2.75C5.6886 2.75 4.08333 4.35526 4.08333 6.33333H4.58333ZM14.0499 12.9301C14.0754 12.9556 14.0833 12.9806 14.0833 13H14.5833C14.5833 12.8327 14.5113 12.6844 14.4034 12.5766L14.0499 12.9301ZM11.1706 10.2772L14.0573 12.9372L14.3961 12.5695L11.5094 9.90949L11.1706 10.2772ZM11.0696 10.7504L11.5229 10.2637L11.1571 9.92294L10.7037 10.4096L11.0696 10.7504ZM13.8363 12.963L11.0563 10.3963L10.7171 10.7637L13.4971 13.3304L13.8363 12.963ZM13.9167 16.3333V13.1467H13.4167V16.3333H13.9167ZM1.66667 16.5833H13.6667V16.0833H1.66667V16.5833ZM1.41667 13.1467V16.3333H1.91667V13.1467H1.41667ZM4.27684 10.3899L1.49684 12.9632L1.83649 13.3301L4.61649 10.7568L4.27684 10.3899ZM3.8104 10.2571L4.26374 10.7437L4.6296 10.4029L4.17626 9.91627L3.8104 10.2571ZM1.27631 12.937L4.16297 10.2703L3.82369 9.90303L0.937026 12.5697L1.27631 12.937ZM1.25 13C1.25 12.9806 1.25795 12.9556 1.28344 12.9301L0.92989 12.5766C0.822049 12.6844 0.75 12.8327 0.75 13H1.25ZM1.25 16.6667V13H0.75V16.6667H1.25ZM1.33333 16.75C1.28474 16.75 1.25 16.7153 1.25 16.6667H0.75C0.75 16.9914 1.00859 17.25 1.33333 17.25V16.75ZM14 16.75H1.33333V17.25H14V16.75ZM14.0833 16.6667C14.0833 16.7153 14.0486 16.75 14 16.75V17.25C14.3247 17.25 14.5833 16.9914 14.5833 16.6667H14.0833ZM14.0833 13V16.6667H14.5833V13H14.0833ZM7.66667 10.0833C6.3314 10.0833 5.25 9.00193 5.25 7.66667H4.75C4.75 9.27808 6.05526 10.5833 7.66667 10.5833V10.0833ZM10.0833 7.66667C10.0833 9.00193 9.00193 10.0833 7.66667 10.0833V10.5833C9.27807 10.5833 10.5833 9.27808 10.5833 7.66667H10.0833ZM10.0833 6.33334V7.66667H10.5833V6.33334H10.0833ZM7.66667 3.91667C9.00193 3.91667 10.0833 4.99808 10.0833 6.33334H10.5833C10.5833 4.72193 9.27807 3.41667 7.66667 3.41667V3.91667ZM5.25 6.33334C5.25 4.99808 6.3314 3.91667 7.66667 3.91667V3.41667C6.05526 3.41667 4.75 4.72193 4.75 6.33334H5.25ZM5.25 7.66667V6.33334H4.75V7.66667H5.25ZM22.3963 10.5697L19.5096 7.90303L19.1704 8.27031L22.057 10.937L22.3963 10.5697ZM22.5833 11C22.5833 10.8327 22.5113 10.6844 22.4034 10.5766L22.0499 10.9301C22.0754 10.9556 22.0833 10.9806 22.0833 11H22.5833ZM22.5833 14.6667V11H22.0833V14.6667H22.5833ZM22 15.25C22.3247 15.25 22.5833 14.9914 22.5833 14.6667H22.0833C22.0833 14.7153 22.0486 14.75 22 14.75V15.25ZM15.6667 15.25H22V14.75H15.6667V15.25ZM15.4167 14.3333V15H15.9167V14.3333H15.4167ZM21.6667 14.0833H15.6667V14.5833H21.6667V14.0833ZM21.4167 11.1467V14.3333H21.9167V11.1467H21.4167ZM18.7168 8.7568L21.4968 11.3301L21.8365 10.9632L19.0565 8.38987L18.7168 8.7568ZM19.1571 7.91627L18.7037 8.40294L19.0696 8.74374L19.5229 8.25707L19.1571 7.91627ZM12.75 5.66667C12.75 7.27808 14.0553 8.58334 15.6667 8.58334V8.08334C14.3314 8.08334 13.25 7.00193 13.25 5.66667H12.75ZM12.75 4.33334V5.66667H13.25V4.33334H12.75ZM15.6667 1.41667C14.0553 1.41667 12.75 2.72193 12.75 4.33334H13.25C13.25 2.99808 14.3314 1.91667 15.6667 1.91667V1.41667ZM18.5833 4.33334C18.5833 2.72193 17.2781 1.41667 15.6667 1.41667V1.91667C17.0019 1.91667 18.0833 2.99808 18.0833 4.33334H18.5833ZM18.5833 5.66667V4.33334H18.0833V5.66667H18.5833ZM15.6667 8.58334C17.2781 8.58334 18.5833 7.27808 18.5833 5.66667H18.0833C18.0833 7.00193 17.0019 8.08334 15.6667 8.08334V8.58334Z"
                                    fill="#6D7080" />
                            </svg>
                            <span>{{$t('page.auditing.dispatch_information')}}</span>
                        </h5>
                    </div>
                </b-card-header>
                <b-card-body>
                    <!--   <table class="table table-bordered table-nowrap align-middle" v-if="!editType">
            <thead class="text-muted table-light">
            <tr class="text-uppercase">
              <th scope="col">代理商</th>
              <th scope="col">NASH服务工程师</th>
              <th scope="col">NASH授权服务工程师</th>
              <th scope="col">联系电话</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th scope="row">{{auditingAssignList.authorized&&auditingAssignList.authorized.company_name}}</th>
              <td>{{auditingAssignList.authorized&&auditingAssignList.authorized.engineer.name||'-'}}</td>
              <td>-</td>
              <td>{{auditingAssignList.authorized&&auditingAssignList.authorized.company_tel}}</td>
            </tr>
            <tr>
              <th scope="row">{{auditingAssignList.original&&auditingAssignList.original.company_name}}</th>
              <td>{{auditingAssignList.original&&auditingAssignList.original.owner_engineer.name||'-'}}</td>
              <td>{{auditingAssignList.original&&auditingAssignList.original.technical_engineer.name||'-'}}</td>
              <td>{{auditingAssignList.original&&auditingAssignList.original.company_tel}}</td>
            </tr>
            </tbody>
          </table>-->
                    <b-row>
                        <b-col class="mt-5" cols="4">
                            <p class="text-muted mb-2 text-uppercase fw-semibold">{{$t('page.auditing.NASH_service')}}</p>
                            <business-card :target-id="currentCompanyId"
                                :title="getAuditingAssignListVal('original.company_name')"
                                :tel="getAuditingAssignListVal('original.company_tel')"
                                :icon="getAuditingAssignListVal('original.logo')" :editable="false"
                                @deleted="deleteCompany" />
                            <set-company-modal :show="showCompanySet" @ok="editCompanyCommit"
                                @cancel="this.showCompanySet = false"></set-company-modal>
                        </b-col>
                        <b-col class="mt-5" cols="4">
                            <p class="text-muted mb-2 text-uppercase fw-semibold">{{$t('page.auditing.sales_service_engineer')}}</p>
                            <b-row>
                                <b-col cols="12"
                                    v-if="auditingAssignList.original && getAuditingAssignListVal('original.owner_engineer.name')"
                                    :target-id="currentAssistEngineerId">
                                    <business-card :title="getAuditingAssignListVal('original.owner_engineer.name')"
                                        :tel="getAuditingAssignListVal('original.owner_engineer.tel')"
                                        :icon="getAuditingAssignListVal('original.owner_engineer.logo')"
                                        :editable="saleRoleCanEdit" @deleted="deleteEngineer('assist')"
                                        @exchange="openEngineerSet('1')" />
                                </b-col>
                                <!-- 添加按钮 -->
                                <b-col cols="3" v-if="!getAuditingAssignListVal('original.owner_engineer.name')"
                                    class="d-flex">
                                    <div :class="{'addIconBox':true, 'disabled': !saleRoleCanEdit}"
                                        @click="saleRoleCanEdit && openEngineerSet('1')">
                                        <span class="addIcon"></span>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="mt-5" cols="4">
                            <p class="text-muted mb-2 text-uppercase fw-semibold">{{$t('page.auditing.technical_service_engineer')}}</p>
                            <b-row>
                                <b-col cols="12"
                                    v-if="auditingAssignList.original&&getAuditingAssignListVal('original.technical_engineer.name')"
                                    :target-id="currentAssistEngineerId">
                                    <business-card :title="getAuditingAssignListVal('original.technical_engineer.name')"
                                        :tel="getAuditingAssignListVal('original.technical_engineer.tel')"
                                        :icon="getAuditingAssignListVal('original.technical_engineer.logo')"
                                        :editable="saleRoleCanEdit" @deleted="deleteEngineer('assist')"
                                        @exchange="openEngineerSet('2')" />
                                </b-col>
                                <!-- 添加按钮 -->
                                <b-col cols="3" v-if="!getAuditingAssignListVal('original.technical_engineer.name')"
                                    class="d-flex">
                                    <div :class="{'addIconBox':true, 'disabled': !saleRoleCanEdit}"
                                        @click="saleRoleCanEdit && openEngineerSet('2')">
                                        <span class="addIcon"></span>
                                    </div>
                                </b-col>
                                <set-engineer-modal ref="setEngineer" :defaultSelectId="defaultSelectIdEngineerId"
                                    :show="showEngineerSet" :engineerType="engineerType"
                                    :company-id="woData.service_company" :province-id="woData.province"
                                    :customer-id="woData.customer" @ok="engineerChanged"
                                    @cancel="this.showEngineerSet = false"></set-engineer-modal>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row v-if="woData.ka_level_txt==='C'">
                        <b-col class="mt-5" cols="4">
                            <p class="text-muted mb-2 text-uppercase fw-semibold">{{$t('page.auditing.agent_service')}}</p>
                            <b-row>
                                <b-col cols="12"
                                    v-if="auditingAssignList.original && getAuditingAssignListVal('authorized.company_name')"
                                    :target-id="currentCompanyId">
                                    <business-card :title="getAuditingAssignListVal('authorized.company_name')"
                                        :tel="getAuditingAssignListVal('authorized.tel')"
                                        :icon="getAuditingAssignListVal('authorized.logo')" :editable="saleRoleCanEdit"
                                        @deleted="deleteCompany" @exchange="openEngineerSet('3')" />
                                </b-col>
                                <!-- 添加按钮 -->
                                <b-col cols="12" v-if="!getAuditingAssignListVal('authorized.company_name')"
                                    class="d-flex">
                                    <div :class="{'addIconBoxFull':true, 'disabled': !saleRoleCanEdit}"
                                        @click="saleRoleCanEdit && openEngineerSet('3')">
                                        <span class="addIcon"></span>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="mt-5" cols="4">
                            <p class="text-muted mb-2 text-uppercase fw-semibold">{{$t('page.auditing.authorized_service_engineer')}}</p>
                            <b-row>
                                <b-col cols="12" v-if="getAuditingAssignListVal('authorized.engineer.name')"
                                    :target-id="currentAssistEngineerId">
                                    <business-card :title="getAuditingAssignListVal('authorized.engineer.name')"
                                        :tel="getAuditingAssignListVal('authorized.engineer.tel')"
                                        :icon="getAuditingAssignListVal('authorized.engineer.logo')"
                                        :editable="agentRoleEdit" @deleted="deleteEngineer('assist')"
                                        @exchange="openEngineerSet('4')" />
                                </b-col>
                                <!-- 添加按钮 -->
                                <b-col cols="12" v-if="!getAuditingAssignListVal('authorized.engineer.name')"
                                    class="d-flex">
                                    <div :class="{'addIconBoxFull':true, 'disabled': !agentRoleEdit}"
                                        @click="agentRoleEdit && openEngineerSet('4')">
                                        <span class="addIcon"></span>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>

        </b-col>

        <!-- 右侧历史设备巡检、服务进度、附件 -->
        <b-col cols="3" v-show="checkTabVal != '3'">
            <b-card no-body>
                <b-card-header>
                    <div class="d-flex">
                        <h5 class="card-title flex-grow-1 mb-0 d-flex align-items-center">
                            <svg class="me-2" xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                                viewBox="0 0 15 15" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15ZM8.0362 7.50064H9.64334C9.9392 7.50069 10.179 7.74058 10.179 8.03645C10.1789 8.33224 9.93914 8.57202 9.64334 8.57207H6.96477V4.82207C6.96477 4.52621 7.20462 4.28636 7.50048 4.28636C7.79635 4.28636 8.0362 4.52621 8.0362 4.82207L8.0362 7.50064ZM13.9287 7.49903C13.9287 11.0494 11.0506 13.9276 7.50016 13.9276C3.94976 13.9276 1.07159 11.0494 1.07159 7.49903C1.07159 3.94863 3.94976 1.07046 7.50016 1.07046C11.0506 1.07046 13.9287 3.94863 13.9287 7.49903Z"
                                    fill="#2C404C" />
                            </svg>
                            <span>{{$t('page.auditing.history')}}&ensp;{{ $t('Auditing') }}</span>
                        </h5>
                    </div>
                </b-card-header>
                <b-card-body class="p-4 overflow-auto">
                    <div>
                        <div v-for="(a,index) in auditingHistory" :key="a.id" class="mb-2 ms-3 position-relative">
                            <div
                                :style="{height: '8px',width:'8px',background:index===0?'#6691E7':'#D9D9D9',position:'absolute',left:'-19px',top:'5px',borderRadius:'50%' }">
                            </div>
                            <div class="d-flex align-items-center">
                                <div style="color: #6691E7;font-size: 14px;font-weight: 400;">{{a.number}}</div>
                                <div class="ms-2" style="color: #878A99;font-size: 12px;font-weight: 400;">
                                    {{a.actual_complete_at}}</div>
                            </div>
                            <div class="d-flex">
                                <div class="d-flex align-items-end">
                                    <div style="color: #878A99;font-size: 13px;font-weight: 400;">{{$t('page.auditing.customer_contact')}} : </div>
                                    <div style="text-decoration-line: underline;font-weight: 700;color:#6D7080">
                                        {{ a.auditing_order_report[0]&&a.auditing_order_report[0].contact_name }}</div>
                                </div>
                                <div class="d-flex align-items-end ms-2">
                                    <div style="color: #878A99;font-size: 13px;font-weight: 400;">{{$t('page.auditing.sales_service_engineer')}} : </div>
                                    <div style="text-decoration-line: underline;font-weight: 700;color:#6D7080">
                                        {{a&&a.owner_engineer_txt}}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </b-card-body>
            </b-card>
            <template v-if="checkTabVal === '2'">
                <!-- 服务进度 -->
                <b-card no-body>
                    <b-card-header>
                        <div class="d-flex">
                            <h5 class="card-title flex-grow-1 mb-0 d-flex align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18"
                                    fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M9.51623 15.6773L13.437 11.9648C15.6021 9.9145 15.602 6.59049 13.4368 4.54032C11.2715 2.49015 7.76099 2.49014 5.59572 4.5403C3.43045 6.59046 3.43032 9.91447 5.59542 11.9648L9.51623 15.6773ZM9.51543 17.7979L4.47464 13.0249C1.69073 10.3889 1.69075 6.11501 4.47467 3.47898C7.2586 0.842952 11.7722 0.842943 14.5562 3.47896C17.3401 6.11497 17.3401 10.3888 14.5562 13.0249L9.51543 17.7979ZM9.51482 9.75122C10.3897 9.75122 11.099 9.07965 11.099 8.25122C11.099 7.4228 10.3897 6.75122 9.51483 6.75122C8.63992 6.75122 7.93067 7.42279 7.93066 8.25121C7.93066 9.07964 8.63991 9.75121 9.51481 9.75122H9.51482ZM9.51597 11.2527C8.38404 11.2527 7.33809 10.6809 6.77213 9.75269C6.20616 8.82448 6.20616 7.68089 6.77213 6.75269C7.33809 5.82448 8.38404 5.25269 9.51597 5.25269C10.6479 5.25269 11.6939 5.82448 12.2598 6.75269C12.8258 7.68089 12.8258 8.82448 12.2598 9.75269C11.6939 10.6809 10.6479 11.2527 9.51597 11.2527Z"
                                        fill="#2C404C" />
                                </svg>
                                <span>{{$t('page.auditing.service_progress')}}</span>
                            </h5>
                        </div>
                    </b-card-header>
                    <b-card-body class="p-4 overflow-auto" style="max-height: 650px">
                        <div>
                            <div v-for="(a,index) in auditingLog" :key="a.id" class="mb-2 ms-3 position-relative">
                                <svg style="position: absolute;left: -17px;top: 15px;" width="2" height="40"
                                    viewBox="0 0 2 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="1.39062" y1="-1.83952e-08" x2="1.39064" y2="40" stroke="#CED4DA"
                                        stroke-dasharray="5 5" />
                                </svg>
                                <div
                                    :style="{height: '8px',width:'8px',background:index===0?'#6691E7':'#D9D9D9',position:'absolute',left:'-19px',top:'5px',borderRadius:'50%' }">
                                </div>
                                <div class="d-flex align-items-end">
                                    <div
                                        :style="{color:index===0?'#6691E7':'#878A99',fontSize: '14px',fontWeight: '600'}">
                                        {{a.tit}}
                                    </div>
                                    <div class="ms-2" style="color: #878A99;font-size: 12px;font-weight: 400;">
                                        {{moment(a.created_at).format("YYYY-MM-DD HH:mm:ss")}}
                                    </div>
                                </div>
                                <div style="color: #878A99;font-size: 13px;font-weight: 400;">{{a.cont}}</div>
                            </div>
                        </div>

                    </b-card-body>
                </b-card>

                <!-- 附件 -->
                <b-card no-body>
                    <b-card-header>
                        <div class="d-flex">
                            <h5 class="card-title flex-grow-1 mb-0 d-flex align-items-center">
                                <svg class="me-2" xmlns="http://www.w3.org/2000/svg" width="15" height="14"
                                    viewBox="0 0 15 14" fill="none">
                                    <path
                                        d="M7.50111 4.05189L9.87568 1.56451C10.3574 1.06058 11.0104 0.77749 11.6912 0.777418C12.372 0.777345 13.0251 1.06029 13.5069 1.56413C13.9882 2.06864 14.2585 2.75272 14.2583 3.46595C14.2582 4.17917 13.9876 4.86314 13.5062 5.36745L9.94542 9.09695V9.09734L7.27449 11.8948C5.77972 13.4605 3.35767 13.4605 1.8629 11.8952C0.367758 10.3294 0.368129 7.79343 1.8655 6.22455L6.01932 1.8734C6.08689 1.80012 6.12428 1.70198 6.12343 1.6001C6.12259 1.49823 6.08358 1.40078 6.01481 1.32875C5.94604 1.25671 5.85301 1.21585 5.75576 1.21496C5.6585 1.21408 5.56481 1.25324 5.49486 1.32401L1.34103 5.67439C-0.446391 7.54711 -0.446762 10.5745 1.33843 12.4445C3.12251 14.3134 6.01487 14.3134 7.79895 12.4445L10.4695 9.64634H10.4699L10.4703 9.64595L14.0306 5.91644C15.3229 4.5628 15.3232 2.36761 14.031 1.01397C12.7402 -0.338118 10.6427 -0.338119 9.35122 1.01474L6.97665 3.50173L3.71449 6.91885C3.52367 7.11808 3.37223 7.35477 3.26884 7.61538C3.16546 7.87598 3.11215 8.15539 3.11198 8.4376C3.11181 8.71982 3.16477 8.9993 3.26784 9.26004C3.37091 9.52079 3.52206 9.75768 3.71263 9.95716C4.09768 10.3595 4.61943 10.5853 5.16328 10.5849C5.70713 10.5845 6.2286 10.3581 6.61315 9.95522L11.0615 5.29596C11.129 5.22268 11.1664 5.12454 11.1656 5.02267C11.1647 4.9208 11.1257 4.82335 11.057 4.75131C10.9882 4.67928 10.8952 4.63841 10.7979 4.63753C10.7007 4.63664 10.607 4.67581 10.537 4.74658L6.08869 9.40622C5.84324 9.66338 5.51042 9.80802 5.16328 9.80839C4.81613 9.80875 4.48303 9.66481 4.2371 9.40817C4.11541 9.28082 4.01891 9.12955 3.95314 8.96306C3.88737 8.79656 3.85362 8.6181 3.85383 8.43791C3.85404 8.25772 3.88819 8.07935 3.95435 7.91302C4.0205 7.74669 4.11734 7.59567 4.23932 7.46862L7.50111 4.05189Z"
                                        fill="#2C404C" />
                                </svg>
                                <span>{{$t('page.attachment')}}</span>
                            </h5>
                        </div>
                    </b-card-header>
                    <b-card-body>
                        <div class="w-100">
                            <div>
                                <div class="border-primary fs-14 material-title">
                                    {{$t('page.on_site_check_in')}}
                                </div>
                            </div>
                            <div class="product-img-slider sticky-side-div">
                                <SwiperTool :swiperInfo="{
                        type: 'image',
                        page: 'modeltag',
                        spaceBetween: 10,
                        slidesPerView: 10,
                        actionsClass: [
                          { name: 'ri-eye-fill', action: 'view' },
                          { name: 'ri-download-2-fill', action: 'download' },
                        ],
                      }" :list="auditingAttachmentList.check_in" :nameType="false" :nextfalse="false">
                                </SwiperTool>
                            </div>
                        </div>
                        <div class="mt-4 mb-4 w-100">
                            <!-- <div>
                                <div class="border-primary fs-14 material-title">
                                    相关附件
                                </div>
                            </div> -->
                            <div class="product-img-slider sticky-side-div">
                                <SwiperTool :swiperInfo="{
                        type: 'document',
                        page: 'modeltag',
                        spaceBetween: 10,
                        slidesPerView: 10,
                        actionsClass: [
                          { name: 'ri-play-circle-line', action: 'play' },
                          { name: 'ri-download-2-fill', action: 'download' },
                        ],
                      }" :list="auditingAttachmentList.attachment" :nameType="false" :nextfalse="false">
                                </SwiperTool>
                            </div>
                        </div>
                        <div class="w-100">
                            <div>
                                <div class="border-primary fs-14 material-title">
                                    {{$t('page.auditing.customer_signature')}}
                                </div>
                            </div>
                            <div class="product-img-slider sticky-side-div">
                                <SwiperTool :swiperInfo="{
                        type: 'image',
                        page: 'modeltag',
                        spaceBetween: 10,
                        slidesPerView: 10,
                        actionsClass: [
                          { name: 'ri-eye-fill', action: 'view' },
                          { name: 'ri-download-2-fill', action: 'download' },
                        ],
                      }" :list="auditingAttachmentList.signature" :nameType="false" :nextfalse="false">
                                </SwiperTool>
                            </div>
                        </div>
                    </b-card-body>
                </b-card>
            </template>

        </b-col>
    </b-row>
</template>
<style scoped lang="scss">
    $disbledColor: #efefef;

    .addIconBox {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 82px;

        &.disabled {
            cursor: not-allowed;

            .addIcon {
                cursor: not-allowed;
                color: $disbledColor;
                border-color: $disbledColor;
            }
        }

        .addIcon {
            cursor: pointer;
            font-size: 3rem;
            color: #d3d3d3;
            user-select: none;
            display: flex;
            width: 4.5rem;
            height: 4.5rem;
            border-radius: 50%;
            border: 1px dashed rgba(109, 112, 128, 1);
            align-items: center;
            justify-content: center;
            box-sizing: border-box;

            &::after {
                content: '+';
                position: relative;
                top: -3px;
            }
        }
    }

    .addIconBoxFull {
        @extend .addIconBox;
        width: 100%;
        border: 1px dashed rgba(109, 112, 128, 1);

        &.disabled {
            border-color: $disbledColor;
        }
    }
</style>
<style>
    .feedback-title {
        vertical-align: middle;
        line-height: 32px;
    }

    .rate-text-active {
        color: #f7ba2a;
    }

    .auditing-card>.card-body {
        padding: 0 !important;
    }
</style>